import { MEDIA_QUERIES } from "@/hooks/responsive";
import { makeStyles, shorthands, tokens } from "@fluentui/react-components";

export const useStyle = makeStyles({
	container: {
		minWidth: "10rem",
		maxWidth: "30rem",
		width: "23rem",
		...shorthands.padding(tokens.spacingVerticalL, "16px"),
		padding: `${tokens.spacingVerticalL} 16px`,

		[`@media ${MEDIA_QUERIES.isMobileMediumToSmall}`]: {
			width: "21rem",
		},
	},
	title: {
		fontSize: tokens.fontSizeBase200,
		fontWeight: tokens.fontWeightBold,
		marginLeft: "12px",
	},
	summaryContainer: {
		fontSize: tokens.fontSizeBase200,
		marginBottom: "8px",
		marginTop: "15px",
		maxHeight: "400px",
		overflowY: "scroll",
		"& p": {
			margin: 0
		},
	},
	skeletonContainer: {
		marginTop: "10px",
	},
	closeButton: {
		paddingTop: "0",
		paddingRight: "0",
	},
	panelHeader: {
		padding: "0px",
		marginBottom: tokens.spacingHorizontalM,
	},
});
